import { NgModule } from '@angular/core';
import { StripeService } from './stripe.service';

@NgModule()
export class DfModuleStripeModule {
    constructor(stripeService: StripeService) {}
}
